<script>
 import { sortedAlerts } from '../store.js';
 import Pagination from './Pagination.svelte';
 import moment from 'moment';

 let displayAlerts = [];

 const paginate = (event) => {
    displayAlerts = event.detail.items;
  }
</script>

<div class="row">
  <div class="col-md-12 stretch-card">
    <div class="card">
      <div class="card-body">
        <p class="card-title">Alerts</p>
        <div class="table-responsive">
          <table id="alerts" class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Date</th>
                <th>Emails Sent</th>
                <th>Calls Attempted</th>
                <th>SMS Sent</th>
                <!--th class='text-center'>Detail</th-->
              </tr>
            </thead>
            <tbody>
              {#if displayAlerts.length}
                {#each displayAlerts as alert}
                  <tr>
                    <td>{moment.unix(alert.created).format('MM/DD/YYYY hh:mm A')}</td>
                    <td>{alert.emailCount}</td>
                    <td>{alert.voiceCount}</td>
                    <td>{alert.smsCount}</td>
                    <!--td class='text-center'>
                      <a>
                        <i class="mdi mdi-file-pdf icon-md mr-3 text-primary"></i>
                      </a>
                    </td-->
                  </tr>
                {/each}
              {:else}
                  <tr>
                    <td colspan='5' class='text-center p-5'>
                      <strong>No Alerts Have Been Sent</strong>
                    </td>
                  </tr>
              {/if}
            </tbody>
            <tfoot>
              <tr>
                <td colspan='6'>
                  <nav class='mt-2' aria-label="Page navigation">
                    <Pagination items={$sortedAlerts} on:paginate={paginate}></Pagination>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>